var module = angular.module('octopusApp.library');

module.controller('CommunityStepTemplateSaveAsController', function ($scope, busy, octopusRepository, action, $uibModalInstance) {
    $scope.newActionName = action.Name + ' Copy';
    $scope.newActionDescription = action.Description;
    $scope.action = action;

    $scope.close = function() {
        $uibModalInstance.close(true);
    };

    $scope.cancel = function() {
        $uibModalInstance.close();
    };

    $scope.save = function() {
        $uibModalInstance.close($scope.newActionName);
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/community_step_template_saveas_controller.js
// module id = 2156581227607962
// module chunks = 1